import CodeUtils from 'draft-js-code';
import PrismDecorator from './highlighting-decorator';
import TextEditorCodeBlock from '../../text-editor-code-block';

export default function CodeBlockPlugin({ backgroundColor }) {
  return {
    keyBindingFn: (event, { getEditorState }) => {
      if (CodeUtils.hasSelectionInBlock(getEditorState())) {
        return CodeUtils.getKeyBinding(event);
      }
    },

    handleKeyCommand: (command, editorState, { setEditorState }) => {
      const newState = CodeUtils.hasSelectionInBlock(editorState) ?
        CodeUtils.handleKeyCommand(editorState, command) :
        null;

      if (newState) {
        setEditorState(newState);
        return 'handled';
      }

      return 'not-handled';
    },

    handleReturn: (event, editorState, { setEditorState }) => {
      if (!CodeUtils.hasSelectionInBlock(editorState)) {
        return 'not-handled';
      }

      setEditorState(CodeUtils.handleReturn(event, editorState));
      return 'handled';
    },

    onTab: (event, { getEditorState, setEditorState }) => {
      const editorState = getEditorState();
      if (CodeUtils.hasSelectionInBlock(editorState)) {
        return setEditorState(CodeUtils.handleTab(event, editorState));
      }
    },

    decorators: [new PrismDecorator()],

    blockRendererFn: (block, { getReadOnly }) => {
      if (block.getType() === 'code-block') {
        return {
          props: { backgroundColor },
          component: TextEditorCodeBlock,
          editable: !getReadOnly(),
        };
      }
    },
    customStyleMap: {
      CODE: {
        display: 'inline-block',
        padding: '0.18em 0.375em',
        fontFamily: 'monospace',
        backgroundColor,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/code-block/index.js